<template>
  <div class="value">
    <div class="number">{{ number }}</div>
    <div class="title">{{ title }}</div>
    <div class="title" v-html="text"></div>
  </div>
</template>

<script>
  import ApiService from '@/services/api/ApiService.js';
  import axios from 'axios';

  export default {
    name: 'Grafico2Valore',
    props: ['value'],
    data() {
      return {
        title: '',
        text: '',
        number: '',
      }
    },
    created() {
      this.title = this.value.attributes.titolo;
      this.text = this.value.attributes.testo;
      this.number = this.value.attributes.valore;
    },
  }

</script>
